import React from 'react';
import { Crown } from 'lucide-react';

// Premium "Necklace Set / Pendant Set" badge; tapping selects every piece of the set together.
export function TagSetBadge({ item, mates, onSelect }) {
  const others = mates.filter((m) => m.id !== item.id);
  const title = `${item.set_type}: ${mates.map((m) => `${m.jewellery_no} (${m.jewellery_type || '—'})`).join(', ')}${onSelect ? ' — tap to select the whole set' : ''}`;
  return (
    <button
      type="button" title={title} disabled={!onSelect}
      onClick={(e) => { e.stopPropagation(); onSelect?.(mates); }}
      className="group/set relative min-w-0 max-w-full overflow-hidden rounded-full p-[1.5px] shadow-[0_4px_14px_-4px_rgba(109,40,217,0.6)] transition-transform duration-200 hover:scale-[1.04] active:scale-95 disabled:cursor-default"
      style={{ background: 'linear-gradient(120deg,#f5d77a,#b8860b 35%,#f9e6a0 60%,#c9a227)' }}
      data-testid="tagws-card-set-badge"
    >
      <span className="relative flex items-center gap-1 overflow-hidden rounded-full px-2 py-0.5 text-white" style={{ background: 'linear-gradient(120deg,#3b0764,#6d28d9 55%,#7c3aed)' }}>
        <span className="pointer-events-none absolute inset-y-0 -left-1/2 w-1/3 skew-x-[-20deg] bg-gradient-to-r from-transparent via-white/35 to-transparent transition-transform duration-700 group-hover/set:translate-x-[400%]" />
        <Crown size={11} className="shrink-0 text-amber-300" />
        <span className="text-[length:calc(var(--fs,1)*0.625rem)] font-bold tracking-wide" style={{ color: '#fde68a' }}>{item.set_type}</span>
        {others.length ? <span className="truncate text-[length:calc(var(--fs,1)*0.5625rem)] font-medium text-violet-100/90" data-testid="tagws-card-set-mates">· with {others.map((m) => m.jewellery_no).join(', ')}</span> : null}
      </span>
    </button>
  );
}
